module.exports = __webpack_public_path__ + "static/media/d-max-hero.43a148ba.jpg";